import type { PropsWithChildren } from "react";

import { Tooltip } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { NotEnoughQuotaTooltip } from "app/pages/sales-intelligence/modules/quota/components/NotEnoughQuotaTooltip";
import { quotaKeys } from "app/pages/sales-intelligence/modules/quota/utils/i18n";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { isNoTouch, isTraditionalTrialUser } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

type Props = PropsWithChildren<{
    quota: number;
    isOutOfQuota: boolean;
}>;

const QuotaTooltip = ({ quota, isOutOfQuota, children }: Props) => {
    const isNoTouchUser = isNoTouch(swSettings);
    const isTrialUser = isTraditionalTrialUser(swSettings);
    if (isOutOfQuota) {
        return (
            <NotEnoughQuotaTooltip
                quota={quota}
                isAdmin={salesSettingsHelper.isAdmin()}
                isNoTouch={isNoTouchUser}
                isTrial={isTrialUser}
            >
                <div>{children}</div>
            </NotEnoughQuotaTooltip>
        );
    }

    if (isNoTouchUser || isTrialUser) {
        return <div>{children}</div>;
    }

    return (
        <Tooltip
            content={
                <Stack width="235px">
                    <Text fontVariant="tooltip">{translate(quotaKeys.quotaCalculationInfo)}</Text>
                    <a
                        href=""
                        target="_blank"
                    >
                        {translate("si.common.learn_more")}
                    </a>
                </Stack>
            }
        >
            <div>{children}</div>
        </Tooltip>
    );
};

export default QuotaTooltip;
